import { getConfigDataServer } from '../../../config'
import { setAttributions, GET_USER_DETAIL_ATTRIBUTIONS } from './actions'
import { getAttributions } from '..'

async function getAttributionsMiddleware ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { uuid } = payload
  try {
    const data = await getAttributions({
      server: getConfigDataServer(config, 'brooklyn'),
      uuid,
      auth,
    })

    store.dispatch(
      setAttributions({ uuid, data }),
    )
  } catch (error) {
    store.dispatch(
      setAttributions({ uuid, error: true }),
    )
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_USER_DETAIL_ATTRIBUTIONS:
      getAttributionsMiddleware({ store, action })
      break
    default:
      break
  }
  next(action)
}
